export default __webpack_public_path__ + "static/media/digitalcard_person.f4492bf1.svg";